import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames/bind';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import * as styles from './FinalPriceWithPickupDiscount.css';

const cx = classNames.bind(styles);

// Displays final price after pickup discount when pickup discount with no FPAC applicable.
const FinalPriceWithPickupDiscount = (props) => {
    const { pickupDiscount, isSticky } = props;
    const price = pickupDiscount.defaults || pickupDiscount.original;
    const finalPriceAfterStickyDiscountStyles = dt([
        'border-solid',
        'border-gray-15',
        'px-2',
        'inline-flex',
    ]);
    const finalPriceAfterNotStickyStyles = dt(['border-solid', 'border-gray-15', 'block', 'py-2']);
    const finalPriceAfterStyles = dt(['text-brand-red']);
    const finalPriceLabelStyles = dt(['font-open-sans-bold']);
    const finalPriceLabelStickyStyles = isSticky && dt(['mx-1', 'block', 'text-xlarge']);
    const finalPricePickUpDiscount = isSticky && `${dt(['relative'])} ${cx('sticky')}`;
    return (
        <span
            data-automation-id="final-price-with-pickup-discount"
            className={cx(
                finalPriceAfterStyles,
                finalPriceAfterNotStickyStyles,
                finalPriceAfterStickyDiscountStyles
            )}
        >
            <span className={cx('price', finalPriceLabelStyles, finalPriceLabelStickyStyles)}>
                {' '}
                {price}
            </span>
            <span
                className={`${dt(['font-open-sans-semibold-italic', 'text-small'])} ${cx(
                    'discountMessage',
                    finalPricePickUpDiscount
                )}`}
            >
                <span className={dt(['pl-1'])}>with Pickup Discount</span>
            </span>
        </span>
    );
};

FinalPriceWithPickupDiscount.defaultProps = {
    pickupDiscount: {},
    isSticky: false,
};

FinalPriceWithPickupDiscount.propTypes = {
    pickupDiscount: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    isSticky: PropTypes.bool,
};

export default FinalPriceWithPickupDiscount;
